/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function WorkorderApproveCommandFromJSON(json) {
    return WorkorderApproveCommandFromJSONTyped(json, false);
}
export function WorkorderApproveCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'targetAssignTo': !exists(json, 'targetAssignTo') ? undefined : json['targetAssignTo'],
        'targetAssignToSecondary': !exists(json, 'targetAssignToSecondary') ? undefined : json['targetAssignToSecondary'],
        'targetJobType': !exists(json, 'targetJobType') ? undefined : json['targetJobType'],
        'targetRequestType': !exists(json, 'targetRequestType') ? undefined : json['targetRequestType'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'approvalDateTime': !exists(json, 'approvalDateTime') ? undefined : (json['approvalDateTime'] === null ? null : new Date(json['approvalDateTime'])),
    };
}
export function WorkorderApproveCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'workorderId': value.workorderId,
        'targetAssignTo': value.targetAssignTo,
        'targetAssignToSecondary': value.targetAssignToSecondary,
        'targetJobType': value.targetJobType,
        'targetRequestType': value.targetRequestType,
        'user': UserToJSON(value.user),
        'approvalDateTime': value.approvalDateTime === undefined ? undefined : (value.approvalDateTime === null ? null : value.approvalDateTime.toISOString()),
    };
}
